import { render, staticRenderFns } from "./Element_extraction.vue?vue&type=template&id=056b362a"
import script from "./Element_extraction.vue?vue&type=script&lang=js"
export * from "./Element_extraction.vue?vue&type=script&lang=js"
import style0 from "./Element_extraction.vue?vue&type=style&index=0&id=056b362a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports